// src/components/common/StarRatingInput.tsx
import { useState } from 'react';

interface StarRatingInputProps {
    rating: number;
    setRating: (rating: number) => void;
}

export function StarRatingInput({ rating, setRating }: StarRatingInputProps) {
    const [hover, setHover] = useState(0);

    return (
        <div className="flex items-center gap-1">
            {[...Array(5)].map((_, index) => {
                const starValue = index + 1;
                return (
                    <button
                        type="button"
                        key={starValue}
                        className={`text-2xl transition-colors ${
                            starValue <= (hover || rating) ? 'text-yellow-400' : 'text-gray-300'
                        }`}
                        onClick={() => setRating(starValue)}
                        onMouseEnter={() => setHover(starValue)}
                        onMouseLeave={() => setHover(0)}
                    >
                        ★
                    </button>
                );
            })}
        </div>
    );
}